import styled from "styled-components"
import config from "../config";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "hooks/use-auth";

interface Props {
	navMenuConfig: any;
	pathname: string;
}

interface ButtonProps {
	isActivePath?: boolean;
}

interface ActiveProps {
	isActive?: boolean;
}


interface ListProps {
	pathname: string,
	title: string
}


const NavMenu = (props: Props) => {
	const auth = useAuth()
	const [isOpen, setIsOpen] = useState(true);
	if (props.navMenuConfig.title === "マスタ") {
		const isActive = props.navMenuConfig.links.some((link: ListProps) => link.pathname === props.pathname);
		const handleOnToggle = (event: any) => {
			setIsOpen(event.target.open);
		}
		const iconStyles = {
			paperAirplane: {
				position: "absolute",
				top: "13px",
				left: "23px",
			},
			triangle: {
				position: "absolute",
				top: "19px",
				right: "13px",
				transform: `rotate(${isOpen ? "0" : "180deg"})`,
			}
		};

		return (
			<Details isActive={isActive} open={isOpen} onToggle={handleOnToggle}>
				<Summary isActive={isActive}>
					<Icon src={window.location.origin + props.navMenuConfig.imgsrc} alt="" />
					{props.navMenuConfig.title}
				</Summary>
				{
					props.navMenuConfig.links.map((link: ListProps, index: number) => {
						return (
							<DetailLinkWrapper key={index} isActivePath={link.pathname === props.pathname}>
								<Link to={link.pathname}>{link.title}</Link>
							</DetailLinkWrapper>
						);
					})
				}
			</Details>
		);
	} else if (props.navMenuConfig.title === "ログアウト") {
		return (
			<LinkWrapper onClick={() => auth.signOut()}>
				<Icon src={window.location.origin + props.navMenuConfig.imgsrc} alt="" />
				<LogoutText>{props.navMenuConfig.title}</LogoutText>
			</LinkWrapper >
		)
	} else {
		return (
			<LinkWrapper isActivePath={props.navMenuConfig.pathname === props.pathname}>
				<Icon src={window.location.origin + props.navMenuConfig.imgsrc} alt="" />
				<Link to={props.navMenuConfig.pathname}>{props.navMenuConfig.title}</Link>
			</LinkWrapper>
		);
	}
}

export default NavMenu;

const Icon = styled.img`
    width: 30px;
    height: 30px;
    margin-right: 8px;
`

const LinkWrapper = styled.div<ButtonProps>`
    display: flex;
    background-color: ${({ isActivePath }) => isActivePath ? config.style.backgroundColor.main : config.style.backgroundColor.sub};
    height: 41px;
    text-align: center;
    padding-left: 12px;
    align-items: center;
    a {
        color: white ;
        display: block;
        font-family: Noto Sans JP;
        font-size: 14px;
        font-weight: 400;
        line-height: 25px;
        letter-spacing: 0.04em;
        text-align: left;
        text-decoration: none;
    }
    `;

const LogoutText = styled.p`
	color: white ;
        display: block;
        font-family: Noto Sans JP;
        font-size: 14px;
        font-weight: 400;
        line-height: 25px;
        letter-spacing: 0.04em;
        text-align: left;
        text-decoration: none;
		cursor: pointer;
`

const DetailLinkWrapper = styled.div<ButtonProps>`
display: flex;
background-color: ${({ isActivePath }) => isActivePath ? config.style.backgroundColor.main : config.style.backgroundColor.sub};
height: 41px;
text-align: center;
padding-left: 52px;
align-items: center;
a {
    color: white ;
    display: block;
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0.04em;
    text-align: left;
    text-decoration: none;
}
`;


const Details = styled.details<ActiveProps>`
  background: ${({ isActive }) => isActive ? config.style.backgroundColor.main : config.style.backgroundColor.sub};
  max-width: 200px;
`;

const Summary = styled.summary<ActiveProps>`
cursor: pointer;
    display: flex;
    color: white;
    height: 41px;
    text-align: center;
    padding-left: 12px;
    align-items: center;
    a {
        color: white ;
        display: block;
        font-family: Noto Sans JP;
        font-size: 14px;
        font-weight: 400;
        line-height: 25px;
        letter-spacing: 0.04em;
        text-align: left;
        text-decoration: none;
    }
`;